/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';
import { comparatorQtr, comparatorQtrNew } from '../../../SharedModules/utilities/utilities';

export const URASoruceHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    showCheckboxIcon: false,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    comparator: comparatorQtr,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Source',
    field: 'rpcParamValue',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'DropdownRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    showDropDownVal: true,
    dropDownValueCol: 'uraSourceDD',
  },
];

export const URACalcHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: false,
  },
  {
    headerName: 'Effective Quarter',
    field: 'effectiveQtr',
    editable: false,
    sortable: true,
    required: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    comparator: comparatorQtr,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'TextBoxRenderer',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Calc Method',
    field: 'calcMethodCd',
    editable: false,
    sortable: true,
    resizable: false,
    required: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'DropdownRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    showDropDownVal: true,
    dropDownValueCol: 'uraCalcMethodDD',
  },
  {
    headerName: 'Brand Percent',
    field: 'calcFixedPct',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'TextBoxRenderer',
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Generic Percent',
    field: 'calcGenericPct',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'TextBoxRenderer',
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const URAPaymentHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRenderer',
    cellEditor: MaxLengthNumericEditor,
    comparator: comparatorQtr,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Update',
    field: 'rpcParamValue',
    editable: false,
    sortable: true,
    showCheckboxIcon: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const InterestCalcHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'effectiveQtr',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Calc Method',
    field: 'calcMethodCd',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'DropdownRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    showDropDownVal: true,
    dropDownValueCol: 'intCalcMethodDD',
  },
  {
    headerName: 'Percent',
    field: 'calcFixedPct',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRenderer',
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const FederalPercentHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Percent',
    field: 'rpcParamValue',
    editable: false,
    sortable: true,
    required: true,
    resizable: false,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const FederalFamilyHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    comparator: comparatorQtr,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Percent',
    field: 'rpcParamValue',
    editable: false,
    sortable: true,
    required: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellRenderer: 'TextBoxRenderer',
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const UnitTypeAuditsHead = [
  {
    headerName: 'Unit Type',
    field: 'shortDescription', // 'testUnitTypeCd',
    editable: false,
    sortable: true,
    columnSpan: 2,
    suppressMenu: false,
    minWidth: Styles.Width_280,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Units greater than unit threshold',
    field: 'testOnInd',
    editable: false,
    sortable: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'CheckboxRenderer',
    showCheckboxIcon: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      display: 'flex',
      justifyContent: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Threshold number of units',
    field: 'testAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRenderer',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Mail Order Multiplier',
    field: 'mailOrderMultiplier',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRenderer',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const CMSReporting = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    resizable: true,
    sortable: false,
    cellRenderer: 'CheckboxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    comparator: comparatorQtrNew,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    sortable: true,
    // required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    comparator: comparatorQtrNew,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Number',
    field: 'cmsRptGroupNum',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_210,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'cmsRptGroupName',
    editable: false,
    sortable: true,
    required: true,
    columnSpan: 3,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  // {
  //   headerName: '',
  //   field: '',
  //   removeColumn: true,
  //   minWidth: 1,
  //   resizable: false,
  //   editable: false,
  // },
  // {
  //   headerName: '',
  //   field: '',
  //   removeColumn: true,
  //   minWidth: 1,
  //   resizable: false,
  //   editable: false,
  // },

  {
    headerName: 'Report Title',
    field: 'cmsRptTitle',
    editable: false,
    sortable: true,
    required: true,
    columnSpan: 2,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export const CMSUtilization = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    cellRenderer: 'CheckboxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    comparator: comparatorQtrNew,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    sortable: true,
    // required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    comparator: comparatorQtrNew,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Number',
    field: 'cmsUtilGroupNum',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_210,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'cmsUtilGroupName',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'TextBoxRenderer',
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export const EnrollmentHead = [
  {
    headerName: 'Actions',
    field: 'delete',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    resizable: true,
    cellRenderer: 'CheckboxRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    required: true,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'TextBoxRenderer',
    comparator: comparatorQtr,

    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Enrollment Timing Code',
    field: 'enrollmentTimingCd',
    editable: false,
    sortable: true,
    required: true,
    cellRenderer: 'DropdownRenderer',
    suppressMenu: false,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    showDropDownVal: true,
    dropDownValueCol: 'enrollmentTimingDD',
  },
  {
    headerName: 'Number of Lives',
    field: 'numOfLives',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'TextBoxRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Comments Exist',
    field: 'cc_COMMENTS_EXIST',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    cellEditor: MaxLengthNumericEditor,
    maxWidth: Styles.Width_110,
    minWidth: Styles.Width_120,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action frr-overflow-visible',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'CommentsRenderer',
  },
];
